import React from "react";

const FreeProductCategoryItem = ({
  title,
  desc,
  onClickHandler,
  buttonText,
}) => {
  return (
    <div className="freeProductCatetory-item-container">
      <div className="freeProductCatetory-item-details-container">
        <h5 className="freeProductCatetory-item-primary-text">{title}</h5>
        <p className="freeProductCatetory-item-secondary-text">{desc}</p>
      </div>
      <div className="freeProductCatetory-item-btn">
        <button onClick={onClickHandler}>{buttonText}</button>
      </div>
    </div>
  );
};

export default FreeProductCategoryItem;
